module.exports = __webpack_public_path__ + "static/img/萌宫天街3.6370c559.png";